import styled, { css } from "styled-components";
import { Colors, Fonts, Scale } from '../../themes';
import { deviceSize } from '../../constants/deviceSize'

export const StyledDialogBulkActions = styled.div`
  margin: 45px 14px 0;
`